import ErrorOutlineIcon from "@material-ui/icons/ErrorOutline";
import PriorityHighIcon from "@material-ui/icons/PriorityHigh";
import ReportProblemOutlinedIcon from "@material-ui/icons/ReportProblemOutlined";
import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined";

/*
 * Prioridade nao pode depender so de cor.
 * =============================================================
 * Cerca de 8% dos homens tem alguma dificuldade para distinguir cores, e
 * um quadro operacional lido as pressas nao pode entregar a informacao
 * mais importante — "isso e critico" — apenas por um tom de vermelho.
 *
 * Por isso cada prioridade carrega tres sinais: rotulo escrito, icone
 * proprio e cor. Qualquer um deles sozinho ja responde a pergunta.
 * =============================================================
 */
export const PRIORIDADES = [
	{
		valor: "normal",
		rotulo: "Normal",
		cor: "#607d8b",
		Icone: InfoOutlinedIcon
	},
	{
		valor: "important",
		rotulo: "Importante",
		cor: "#1e88e5",
		Icone: ReportProblemOutlinedIcon
	},
	{
		valor: "urgent",
		rotulo: "Urgente",
		cor: "#f57c00",
		Icone: PriorityHighIcon
	},
	{
		valor: "critical",
		rotulo: "Critico",
		cor: "#d32f2f",
		Icone: ErrorOutlineIcon
	}
];

export const prioridadeDe = valor =>
	PRIORIDADES.find(item => item.valor === valor) || PRIORIDADES[0];

export const formatarDataHora = valor => {
	if (!valor) return "";

	const data = new Date(valor);
	if (Number.isNaN(data.getTime())) return "";

	return data.toLocaleString("pt-BR", {
		day: "2-digit",
		month: "2-digit",
		year: "numeric",
		hour: "2-digit",
		minute: "2-digit"
	});
};

export const formatarData = valor => {
	if (!valor) return "";

	const data = new Date(valor);
	if (Number.isNaN(data.getTime())) return "";

	return data.toLocaleDateString("pt-BR");
};

/*
 * Datas para o <input type="datetime-local">, que so aceita o formato
 * local sem fuso. `toISOString()` converteria para UTC e a hora apareceria
 * tres horas adiantada no formulario.
 */
export const paraCampoDeDataHora = valor => {
	const data = valor ? new Date(valor) : new Date();
	if (Number.isNaN(data.getTime())) return "";

	const doisDigitos = numero => String(numero).padStart(2, "0");

	return [
		data.getFullYear(),
		"-",
		doisDigitos(data.getMonth() + 1),
		"-",
		doisDigitos(data.getDate()),
		"T",
		doisDigitos(data.getHours()),
		":",
		doisDigitos(data.getMinutes())
	].join("");
};
